export enum AlertType {
	info = 'info',
	success = 'success',
	warning = 'warning',
	error = 'error',
	green = 'green',
}
